import { usePublicNotices } from "../../lib/queries/notices";
import { NoticesView } from "./NoticesView";
import { ANSWERED_PREFIX, DISMISSED_PREFIX, useStoredIds } from "./useStoredIds";

/**
 * Oznámení for somebody with no account yet: the login page and the
 * public registration. There is nobody to record „Rozumím" against, so
 * this browser remembers it.
 */
export function PublicNotices() {
  const { data = [] } = usePublicNotices();
  const answered = useStoredIds("local", `${ANSWERED_PREFIX}public`);
  const notices = data.filter((n) => n.display !== "popup" || !answered.ids.has(n.id));
  return (
    <NoticesView
      layout="public"
      dismissible={false}
      dismissKey={`${DISMISSED_PREFIX}public`}
      notices={notices}
      onAcknowledge={answered.add}
    />
  );
}
